import React, { useEffect, useState } from "react";
import { Input, toAbsoluteUrl } from "sr/helpers";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { Checkbox } from "sr/helpers";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { businessTypes, intentType } from "sr/i18n/messages/setting";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";
import { useFormik } from "formik";
import { registerCompany } from "sr/utils/api/company/registerCompany";
import companyRegisterSchema from "sr/utils/schemas/company/companyRegister";
import { useNavigate } from "react-router-dom";
import { sendOTP } from "sr/utils/api/sendOTP";
import { login } from "sr/utils/api/login";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { useAuth } from "../module/auth";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import { ReactSelect } from "sr/helpers/ui-components/ReactSelect";
import { CreateWallet } from "sr/utils/api/wallet/CreateWallet";
import { scrollToError } from "sr/helpers/functions/scrollToError";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import AutoLocation from "sr/helpers/ui-components/AutoLocation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { renderRequiredLabel } from "sr/utils/helper";
import { toast } from "react-toastify";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCompany } from "sr/utils/api/company/getCompany";
import { updateCompany } from "sr/utils/api/company/updateCompany";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { useDispatch } from "react-redux";
import { AppDispatch } from "sr/redux/store";

export default function RegisterCompany({ targetProfile = false }: { targetProfile?: boolean }) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const intl = useIntl();
  const [businessType, setBusinessType] = useState([]);
  const [intent, setIntent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [mobileNo, setMobileNo] = useState();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [companyName, setCompanyName] = useState();
  const [loader, setLoader] = useState(false);
  const [registerType, SetRegisterType] = useState();
  const [allowMessage, setAllowMessage] = useState(false);
  const [address, setAddress] = useState({});
  const [smsOptOut, setSmsOptOut] = useState<boolean>(true);
  const { persistToken, setOnboardingStatus } = useAuth();
  const validationErrorHandle = useValidationErrorHandle();
  const [showPassword, setShowPassword] = useState(false);
  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();
  const [regions, setRegions] = useState([]);
  const [optNearbyRegions, setOptNearbyRegions] = useState(false);
  const [targetProfileId, setTargetProfileId] = useState<string>();
  const initialValues = {
    username: username,
    password: password,
    email: email,
    mobile_number: mobileNo,
    company_name: companyName,
    business_type: businessType,
    intent: intent,
    candidate_msg: allowMessage,
    address: address,
    sms_opt_out: smsOptOut,
    first_name: firstName,
    last_name: lastName,
    regions: regions,
  };
  const {
    errors,
    values,
    submitForm,
    setFieldValue,
    setFieldTouched,
    touched,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: targetProfile
      ? companyRegisterSchema.omit(["username", "password"])
      : companyRegisterSchema,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        console.log("values", values);
        // return;
        if (optNearbyRegions && regions.length === 0) {
          toast.error("Please select at least one nearby region.");
          return;
        }

        setLoader(true);
        if (targetProfile) {
          const result = await updateCompany({
            ...values,
            username: undefined,
            password: undefined,
            id: targetProfileId || getUserDetails()?.user_id,
            onBoardingStatus: true,
          });
          if (result?.success) {
            setOnboardingStatus(true);
            dispatch({ type: "RESET_STATE" });
            navigate("/company-profile", { replace: true });
          }
          setLoader(false);
          return;
        }
        const result = await registerCompany({
          ...values,
          onBoardingStatus: true,
        });
        if (result) {
          const otpresult = await sendOTP({ username: result?.username });
          const data = {
            username: username,
            password: password,
          };

          const loginresult = await login(data);
          if (loginresult?.success === true) {
            const data = {
              userType: loginresult?.data?.user.type,
              user_id: loginresult?.data?.auth.user_id,
            };
            localStorage.setItem("auth", JSON.stringify(data));
            persistToken(
              loginresult?.data?.auth.jwt,
              loginresult?.data?.auth?.onBoardingStatus ??
                loginresult?.data?.onBoardingStatus
            );
            const walletres = await CreateWallet({
              owner_id: loginresult?.data?.auth.user_id,
              owner_type: "COMPANY",
            });
            setLoader(false);
            navigate("/verify-otp");
          }
        } else {
          setLoader(false);
        }
      } catch (e: any) {
        setLoader(false);
      }
    },
  });
  const HandleAutoLocation = (address) => {
    setAddress(address);
  };
  useEffect(() => {
    scrollToError(errors);
  }, [errors]);
  useEffect(() => {
    console.log("regions", regions);
    
    setFieldValue("regions", regions);
  }, [regions]);
  useEffect(() => {
    let isMounted = true;
    const loadTargetProfile = async () => {
      if (!targetProfile) return;
      const id = getUserDetails()?.user_id;
      if (!id) return;
      setTargetProfileId(id);
      setLoader(true);
      try {
        const response = await getCompany(new URLSearchParams({ id }));
        const data = response?.data;
        if (!data || !isMounted) return;
        const userResponse = await getUserFullProfile();
        if (!isMounted) return;
        const sharedRegion = userResponse?.data?.regions?.[0]?.regionId;
        const companyAddress = data.address || {};
        const regionId = companyAddress.regionId || sharedRegion?.id || sharedRegion?._id;
        setTargetProfileId(data.id || data._id || id);
        setCompanyName(data.company_name || "");
        setFirstName(data.first_name || "");
        setLastName(data.last_name || "");
        setMobileNo(data.mobile_number || "");
        setEmail(data.email || "");
        setBusinessType(data.business_type || []);
        setIntent(data.intent || []);
        setAllowMessage(data.candidate_msg ?? false);
        setSmsOptOut(data.sms_opt_out ?? true);
        setAddress(regionId ? { ...companyAddress, regionId } : companyAddress);
        setRegions(data.regions || []);
      } finally {
        if (isMounted) setLoader(false);
      }
    };
    loadTargetProfile();
    return () => {
      isMounted = false;
    };
  }, [targetProfile]);
  const options = businessTypes?.map((item) => ({
    value: item?.value, // Assuming `value` exists
    label: <FormattedMessage id={item?.label} />,
  }));

  return (
    <>
      {targetProfile && loader && <LoaderFullScreen />}
      {/* <AuthNavComponent></AuthNavComponent> */}
      <main>
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
          <div className="lg:flex block">
            <div className="lg:flex-1 lg:flex block w-full flex-col h-fit lg:mx-12 mx-auto lg:p-6  px-4 py-4 bg-white border border-gray-border rounded-xl">
              <div className="flex justify-center">
                <Link to="/create-company" className="z-50">
                  <img
                    width={150}
                    src={toAbsoluteUrl("/media/logos/logo2.png")}
                    alt=""
                    className="bg-white rounded-lg"
                  />
                </Link>
              </div>
              <h1 className=" text-xl mt-10">
                {targetProfile ? "Complete your profile" :
                <FormattedMessage
                  id="ECOMMERCE.COMMON.CREATE_AN_ACCOUNT.TEXT"
                  defaultMessage="Create an Account"
                />}
              </h1>
              <h3 className=" text-md">As Company</h3>
              <div className="w-full">
                <form>
                  <Input
                    onChange={(e: any) => setCompanyName(e.target.value)}
                    error={errors.company_name}
                    value={companyName}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "RECRUITER.REGISTER.INPUT.COMPANYNAME",
                        defaultMessage: "Company Name",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "RECRUITER.REGISTER.INPUT.COMPANYNAME.PLACEHOLDER",
                      defaultMessage: "Enter your Company Name",
                    })}
                    type={"text"}
                  ></Input>
                  <Input
                    value={firstName}
                    onChange={(e: any) => setFirstName(e.target.value)}
                    error={errors.first_name}
                    label="First Name"
                    placeholder="Enter your first name"
                    type="text"
                  />

                  <Input
                    value={lastName}
                    onChange={(e: any) => setLastName(e.target.value)}
                    error={errors.last_name}
                    label="Last Name"
                    placeholder="Enter your last name"
                    type="text"
                  />
                  {!targetProfile && <Input
                    value={username}
                    onChange={(e: any) => setUsername(e.target.value)}
                    error={errors.username}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.USERNAME",
                        defaultMessage: "Username",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.USERNAME.PLACEHOLDER",
                      defaultMessage: "Enter your user name",
                    })}
                    type={"text"}
                  ></Input>}
                  {!targetProfile && <div className="relative">
                    <Input
                      onChange={(e: any) => setPassword(e.target.value)}
                      value={password}
                      error={errors.password}
                      label={renderRequiredLabel(
                        intl.formatMessage({
                          id: "AUTH.INPUT.PASSWORD",
                          defaultMessage: "Password",
                        }),
                      )}
                      placeholder={intl.formatMessage({
                        id: "AUTH.INPUT.PASSWORD.PLACEHOLDER",
                        defaultMessage: "Enter your password",
                      })}
                      type={showPassword ? "text" : "password"}
                    />

                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-9 cursor-pointer text-gray-600"
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                      />
                    </span>
                  </div>}
                  <Input
                    onChange={(e) => setMobileNo(e.target.value)}
                    value={InputNumberFormat(mobileNo)}
                    error={errors.mobile_number}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.MOBILENO",
                        defaultMessage: "Mobile Number",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.LASTMOBILENONAME.PLACEHOLDER",
                      defaultMessage: "Enter your Mobile Number",
                    })}
                    type={"tel"}
                  ></Input>
                  <Input
                    error={errors.email}
                    onChange={(e: any) => setEmail(e.target.value)}
                    value={email}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.EMAIL.ADDRESS",
                        defaultMessage: "Email Address",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.EMAIL.PLACEHOLDER",
                      defaultMessage: "Enter your email id",
                    })}
                    type={"email"}
                    readOnly={targetProfile}
                  ></Input>
                  <div className="required-address-autolocation">
                    <AutoLocation
                      // showRegion={typec === "setting"}
                      showRegion={true}
                      NoregionFetch={true}
                      restrictregionchange={false}
                      showMultiRegion={true}
                      regions={regions}
                      setRegions={setRegions}
                      isHideLatLang={true}
                      setOptNearbyRegions={setOptNearbyRegions}
                      HandleAutoLocation={HandleAutoLocation}
                      address={address}
                      errors={errors?.address || {}}
                      label={renderRequiredLabel(
                        intl.formatMessage({
                          id: "INPUT.ADDRESS1.TITLE",
                          defaultMessage: "Address 1",
                        }),
                      )}
                    ></AutoLocation>
                  </div>
                  <div className="relative w-full">
                    <div onClick={() => setShowModal(!showModal)}>
                      <ReactSelect
                        label={renderRequiredLabel(
                          <FormattedMessage
                            id="RECRUITER.REGISTER.INPUT.SELECT.BUSSINESS.TYPE"
                            defaultMessage="Select Business Type"
                          />,
                        )}
                        placeholder="Select Business Type"
                        type="text"
                        onChange={(selectedOptions) =>
                          setBusinessType(
                            selectedOptions.map((option) => option.value),
                          )
                        }
                        error={errors.business_type}
                        value={businessType}
                        isMulti={true}
                        options={options}
                        defaultValue={options?.filter((item) =>
                          businessType?.includes(item?.value),
                        )}
                      />
                    </div>
                  </div>
                  <div className="mt-10 mb-1 text-gray-700 text-sm ">
                    {renderRequiredLabel(
                      <FormattedMessage
                        id="RECRUITER.REGISTER.INPUT.SELECT.INTENT"
                        defaultMessage="Select Intent"
                      />,
                    )}
                  </div>
                  <div>
                    <div className="flex justify-start space-x-3">
                      {intentType.map((data, index) => (
                        <Checkbox
                          labelClass="font-normal"
                          key={index}
                          checked={intent.includes(data.value)}
                          label={data.label}
                          id={data.value}
                          name={data.value}
                          value={data.value}
                          onChange={(e) => CheckBoxHandle(e, intent, setIntent)}
                        />
                      ))}
                    </div>
                    {errors?.intent && (
                      <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
                        {validationErrorHandle(errors?.intent)}
                      </p>
                    )}
                  </div>
                  <div className="mt-5">
                    <p className="mt-10 mb-1 text-gray-700 text-sm ">
                      {renderRequiredLabel(
                        <FormattedMessage
                          id="RECRUITER.POSTJOB.SETPREFERENCE.ALLOWCANDIDATE.TITLE"
                          defaultMessage="Do you want to allow candidates who apply to message you?"
                        />,
                      )}
                    </p>
                    <div className="flex space-x-6">
                      <RadioInput
                        name="Yes"
                        value={true}
                        label={
                          <FormattedMessage
                            id="RECRUITER.POSTJOB.SETPREFERENCE.ALLOWCANDIDATE.YES"
                            defaultMessage="Yes"
                          />
                        }
                        checked={allowMessage}
                        onChange={() => {
                          setAllowMessage(true);
                        }}
                      />
                      <RadioInput
                        name="No"
                        value={false}
                        label={
                          <FormattedMessage
                            id="RECRUITER.POSTJOB.SETPREFERENCE.ALLOWCANDIDATE.NO"
                            defaultMessage="No"
                          />
                        }
                        checked={allowMessage === false}
                        onChange={() => {
                          setAllowMessage(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="mt-6 border border-gray-300 rounded-md p-4 bg-gray-50">
                    <p className="font-semibold text-sm mb-3">
                      {renderRequiredLabel("SMS Opt-In Agreement")}
                    </p>

                    <div className="space-y-2">
                      <RadioInput
                        name="sms_opt_out"
                        value={false}
                        label="Yes, I would like to receive SMS"
                        checked={values.sms_opt_out === false}
                        onChange={() => {
                          setSmsOptOut(false);
                          setFieldValue("sms_opt_out", false);
                        }}
                      />

                      <RadioInput
                        name="sms_opt_out"
                        value={true}
                        label="No, I would not like to receive SMS"
                        checked={values.sms_opt_out === true}
                        onChange={() => {
                          setSmsOptOut(true);
                          setFieldValue("sms_opt_out", true);
                        }}
                      />
                    </div>

                    <p className="text-xs text-gray-500 mt-3 leading-relaxed">
                      By opting in, you will receive 1 or more text messages per
                      month related to job applicants, work order updates,
                      supervisor updates, promotions, and more. You can update
                      this later in your account settings. Message and data
                      rates may apply. Reply STOP to unsubscribe or HELP for
                      help.{" "}
                      <a
                        href="https://janijobs.com/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://support.janijobs.com/hc/en-us/articles/42346401405723-JaniJobs-Global-Terms-and-Conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        Terms and Conditions
                      </a>{" "}
                      apply.
                    </p>

                    {errors?.sms_opt_out && (
                      <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
                        Please select Text Message opt out option
                      </p>
                    )}
                  </div>
                  {/* <Link to="/verify-otp" replace> */}

                  {/* </Link> */}
                </form>
                <div className="flex justify-center">
                  <ButtonAuth
                    loader={loader}
                    onClick={() => {
                      submitForm();
                      if (!targetProfile) localStorage.setItem("RegisterAs", "Company");
                    }}
                  >
                    {targetProfile ? "Continue" : <FormattedMessage id="AUTH.GENERAL.CREATE.ACCOUNT.BUTTON" defaultMessage="Create Account" />}
                  </ButtonAuth>
                </div>
                {!targetProfile && <div className="mt-10 space-x-1 flex justify-center">
                  <span>
                    <FormattedMessage
                      id="AUTH.ALREADY.HAVE.ACCOUNT"
                      defaultMessage="Already have an account?"
                    />
                  </span>
                  <Link
                    to="/auth"
                    className="cursor-pointer hover:text-pink underline"
                    replace
                  >
                    <FormattedMessage
                      id="AUTH.SIGN_IN_HERE"
                      defaultMessage="Sign in here"
                    />
                  </Link>
                </div>}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
